import { render, staticRenderFns } from "./PersonPorsant.vue?vue&type=template&id=44d37e4e&"
import script from "./PersonPorsant.vue?vue&type=script&lang=js&"
export * from "./PersonPorsant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports